<script setup>
defineProps({
  stages: {
    type: Array,
    default: () => [],
  },
  selectedField: {
    type: Object,
    default: () => ({}),
  },
  supportedTypes: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['selected', 'expression']);
</script>

<template>
  <hawk-menu position="fixed" additional_trigger_classes="!ring-0 !focus:ring-0 !px-2 !py-0" additional_dropdown_classes="transition duration-150 ease-in-out">
    <template #trigger="{ open }">
      <div class="flex items-center text-sm text-right">
        <div v-if="selectedField?.alias" class="text-gray-900">
          {{ selectedField.alias }}
        </div>
        <div v-else class="text-gray-600">
          {{ $t('Not Mapped') }}
        </div>
        <IconHawkChevronDown class="size-4  min-w-4 ml-2" :class="{ 'rotate-180': open }" />
      </div>
    </template>
    <template #content="{ close }">
      <bi-query-builder-column-picker :stages="stages" :stage-index="stageIndex" :has-functions="false" :show-stage-header="true" :supported-types="supportedTypes" @selected="emit('selected', $event);close()" />
    </template>
  </hawk-menu>
</template>
